import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { PlansAndPurchaseTabController } from '../controller/PlansAndPurchaseTabController';
import { SwitchValue } from '../../purchasePage/types';

export class PlansAndPurchaseTabWebComponent extends BaseWebComponentElement {
  public controller!: PlansAndPurchaseTabController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PlansAndPurchaseTabController,
    });
  }

  public refresh() {
    this.controller.view.hasErrorState = false;

    // force re-render
    this.propertiesSet = false;
    this.propertiesSet = true;
  }

  public setSelectedProduct(productId: number, switchValue: SwitchValue) {
    this.controller.view.setSelectedProduct(productId, switchValue);
  }

  public hasErrorState() {
    return this.controller.view.hasErrorState;
  }
}
